import { Component, Input } from '@angular/core';
import { UserContext } from '@core/models';
import { Clients } from '@shared/enums';
import { Table } from '@shared/models';
import * as ProgramCodeThemeConstants from '@core/constants/program-code-theme-constants';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

@Component({
  selector: 'sp-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss'],
})
export class SummaryTableComponent {
  @Input() table: Table;
  @Input() set userContext(val: UserContext) {
    if (val && val.programCode) {
      if (
        ProgramCodeConstants.SurepayrollProgramCodeConstants.indexOf(
          val.programCode.toLowerCase()
        ) >= 0
      ) {
        this.circleColors = ProgramCodeThemeConstants.SurepayrollSummaryThemeColors;
      } else if (
        ProgramCodeConstants.PaychexProgramCodeConstants.indexOf(val.programCode.toLowerCase()) >= 0
      ) {
        this.circleColors = ProgramCodeThemeConstants.PaychexSummaryThemeColors;
      } else if (
        ProgramCodeConstants.TruistProgramCodeConstants.indexOf(val.programCode.toLowerCase()) >= 0
      ) {
        this.circleColors = ProgramCodeThemeConstants.TruistSummaryThemeColors;
      } else if (
        ProgramCodeConstants.RunpayrollProgramCodeConstants.indexOf(
          val.programCode.toLowerCase()
        ) >= 0
      ) {
        this.circleColors = ProgramCodeThemeConstants.RunpayrollSummaryThemeColors;
      }
    }
  }

  circleColors: string[];
}
